import AnalyticsIndex from '@/components/Analytics/Index'
import AnalyticsDaily from '@/components/Analytics/Daily'
import AnalyticsDailyList from '@/components/Analytics/DailyList'
import AnalyticsCustomerStatus from '@/components/Analytics/CustomerStatus'
import CsvIndex from '@/components/Csv/Index'
import NotFound from '@/components/404'

export default [
  {
    path: 'analytics/daily/',
    name: 'AnalyticsDaily',
    component: AnalyticsDaily,
  },
  {
    path: 'analytics/daily-list/',
    name: 'AnalyticsDailyList',
    component: AnalyticsDailyList,
  },
  {
    path: 'analytics/customer-status/',
    name: 'AnalyticsCustomerStatus',
    component: AnalyticsCustomerStatus,
  },
  {
    path: 'analytics/',
    name: 'Analytics',
    component: AnalyticsIndex,
  },
  {
    path: 'csv-export/',
    name: 'CsvExport',
    component: CsvIndex,
  },
  {
    path: '*',
    component: NotFound,
  },
]



// WEBPACK FOOTER //
// ./src/router/admin.js